import React from 'react';
import { connect } from 'react-redux';
import CloseIcon from '../../components/CloseIcon';

const onClose = () => {
  const { onTrigger } = window.xprops;
  onTrigger?.('closeModal');
};

function CloseModalIcon(props) {
  const { isDemo, onCloseFn, setting } = props;
  const mode = window.xprops?.widgetMode || setting.mode;
  const isPopupMode = mode === 'popup' || mode === 'button';

  if (!isPopupMode || isDemo) return null;

  return (
    <CloseIcon
      classes="popup"
      onCloseFn={onCloseFn}
      onClick={onClose}
    />
  );
}

export default connect(({ settings: { setting = {} } }) => ({
  setting,
  isDemo: window.bta && !!window.bta.isDemo,
}))(CloseModalIcon);
